import { useState } from 'react';

export const FAQS = [
  {
    question: '17吃瓜网主要有哪些板块？',
    answer:
      '目前分为娱乐区、社会区、科技圈、体育圈和网红圈五个板块。每个板块的范围不同：娱乐区偏综艺、剧集和舞台话题，社会区关注城市生活与公共话题，科技圈追踪数码新品与人工智能，体育圈看赛事和城市运动，网红圈则聚焦直播与短视频的内容生态。',
  },
  {
    question: '内容大概多久更新一次？',
    answer:
      '整理内容通常在工作日的上午和傍晚各更新一批，遇到热点集中的时段会临时加更。首页的「最新更新」区块展示的就是近期整理好的话题，按时间从近到远排列。',
  },
  {
    question: '站里的内容是消息源吗？',
    answer:
      '不是。站内内容属于话题整理与观察记录，重点是把讨论的背景和几个看点讲清楚，方便你快速了解大家在聊什么。涉及具体事件时，请以官方或当事人公开的信息为准。',
  },
  {
    question: '怎么最快找到我关心的分区？',
    answer:
      '两个办法：一是直接点顶部导航里的板块名称；二是在首页「板块导航」区域选择对应分区，进入后可以看到该分区的全部整理内容，还能按标签继续筛选。',
  },
  {
    question: '手机上浏览方便吗？',
    answer:
      '页面做了移动端适配，手机上会自动收起导航，点右上角的菜单按钮即可展开。阅读页会优先展示要点，方便在通勤或排队时快速看完。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 border-y border-background-200 bg-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-14 md:px-6 md:py-16 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <span className="text-xs font-medium tracking-[0.25em] text-accent-700">常见问题</span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            逛之前先看这几条
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于板块划分、更新节奏和内容定位的常见疑问，都整理在这里。还有别的问题可以直接给我们发邮件。
          </p>
          <div className="mt-6 flex h-14 w-14 items-center justify-center rounded-lg bg-accent-100 text-accent-800">
            <i className="ri-question-answer-line text-2xl" />
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="flex flex-col gap-3">
            {FAQS.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.question}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                      {item.question}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {item.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}